import {IStore} from '../store';
import {IPlaylistsStore} from './playlists.interface';
import {SpotifyPlaylist} from '../../spotify/spotifyPlaylist';

export const playlistsSelector: (state: IStore) => IPlaylistsStore =
  (state: IStore) => state.playlists;

export const userPlaylistsSelector: (state: IStore) => SpotifyPlaylist[] =
  (state: IStore) => playlistsSelector(state).playlists;
